import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './en.json';
import hr from './hr.json';
import type { Lang } from '@/lib/format';

const STORAGE_KEY = 'kinta.lang';

export const languages: { code: Lang; label: string }[] = [
  { code: 'en', label: 'English' },
  { code: 'hr', label: 'Hrvatski' },
];

function read(): string | null {
  try {
    return localStorage.getItem(STORAGE_KEY);
  } catch {
    return null;
  }
}

export function detectLang(): Lang {
  const saved = read();
  if (saved === 'en' || saved === 'hr') return saved;
  return navigator.language.toLowerCase().startsWith('hr') ? 'hr' : 'en';
}

export function setLang(lang: Lang): void {
  try {
    localStorage.setItem(STORAGE_KEY, lang);
  } catch {
    /* private mode: the choice just will not persist */
  }
  document.documentElement.lang = lang;
  void i18n.changeLanguage(lang);
}

void i18n.use(initReactI18next).init({
  resources: { en: { translation: en }, hr: { translation: hr } },
  lng: detectLang(),
  fallbackLng: 'en',
  interpolation: { escapeValue: false },
  returnNull: false,
});
document.documentElement.lang = detectLang();

export default i18n;
export function currentLang(): Lang {
  return i18n.language === 'hr' ? 'hr' : 'en';
}
